import { useDispatch } from 'react-redux'
import { createStripeCheckoutSession } from '../../features/paymentSlice'
import { loadStripe } from '@stripe/stripe-js'
import ButtonCustom from '../atoms/button/ButtonCustom'
import { toastHelper } from '../../util/toastHelper'
import { createPaymentSession } from '../../features/v2/subscriptionSlice'

const stripePromise =
	process.env.REACT_APP_NODE_ENV === 'production'
		? loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY)
		: loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY_DEV)

export const StripeCheckOutButton = ({
	data,
	label = 'Subscribe with Stripe',
	className,
}) => {
	const dispatch = useDispatch()

	const handleClick = async () => {
		if (!stripePromise)
			return toastHelper('Error with Stripe payment', 'error')
		try {
			if (data.priceId) {
				const result = await dispatch(createPaymentSession(data)).unwrap()
				if (!result || !result.checkoutUrl)
					throw new Error('Failed to create payment session')
				window.location.replace(result.checkoutUrl)
			} else {
				const result = await dispatch(
					createStripeCheckoutSession(data)
				).unwrap()
				if (!result || !result.sessionId)
					throw new Error('Failed to create payment session')
				const stripe = await stripePromise
				stripe.redirectToCheckout({ sessionId: result.sessionId })
			}
		} catch (err) {
			console.error('Payment initiation failed:', err.message)
			toastHelper(err.message || 'Failed to create payment session', 'error')
		}
	}

	return (
		<ButtonCustom size="md" onClick={handleClick} className={className}>
			{label}
		</ButtonCustom>
	)
}
